import styled, { css } from 'styled-components'

export const StyledWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 70px;

  ${props =>
    css`
      color: ${props.theme.colors.primary};
    `}
`
